angular.module('env.custom.customTemplate', [])

    .directive('customTemplate', function ($log, $q, $compile, $http, templateResolver, context, customResourceResolver) {

        function link(scope, element, attributes) {

            var oldCustomTemplateUrl = null; // old value of resolved image url

            var recompile = function () {

                var customAliasExpression = element.attr("name");
                var conditionContextExpression = element.attr("context");
                var failOverUri = element.attr("failover-uri");

                var useFailOver = false;
                var customAlias = "";
                var conditionContext = {};

                processExpressions();

                if (useFailOver) {
                    useFailoverTemplate();
                } else {
                    customResourceResolver.resolveTemplateUri(customAlias, failOverUri, conditionContext).then(function (customTemplateUrl) {
                        if (customTemplateUrl == oldCustomTemplateUrl) {
                            return;
                        }
                        oldCustomTemplateUrl = customTemplateUrl;

                        //Use specified template or a failover one in case of wrong custom template uri
                        if (customTemplateUrl && _.isString(customTemplateUrl)) {
                            $log.trace("Fetching custom template [%s] to use with 'ng-include' from [%s].", customAlias, customTemplateUrl);
                            downloadAndBindHtml(customTemplateUrl);
                        } else {
                            $log.warn("Can't find custom template for name '%s'", customAlias);
                            useFailoverTemplate();
                        }
                    });
                }

                function processExpressions() {
                    if (!customAliasExpression || !_.isString(customAliasExpression)) {
                        $log.warn("'custom-template' directive has no 'name' attribute. Using failover template");
                        useFailOver = true;
                        return;
                    }

                    try {
                        customAlias = scope.$eval(customAliasExpression);
                    } catch (e) {
                        $log.error("'custom-template' directive can't evaluate expression from 'name' attribute. Using failover template", e);
                        useFailOver = true;
                        return;
                    }

                    try {
                        conditionContext = scope.$eval(conditionContextExpression);
                    } catch (e) {
                        $log.error("'custom-template' directive can't evaluate expression from 'context' attribute", e);
                        conditionContext = {};
                    }
                }

                function useFailoverTemplate() {
                    if (angular.isDefined(failOverUri) && angular.isString(failOverUri)) {
                        $log.trace("Using template specified in failover-uri [%s].", failOverUri);
                        downloadAndBindHtml(failOverUri);
                    } else {
                        $log.warn("'custom-template' directive was unable to use custom template as well as failover template. Nothing rendered!");
                    }
                }

                function downloadAndBindHtml(uri) {
                    return templateResolver.resolve(uri)
                        .then(function (template) {
                            try {
                                connectHTML(template);
                                return template;
                            } catch (err) {
                                $log.error("'custom-template' directive was unable to bind custom template. Nothing rendered!", err);
                                return $q.reject(err);
                            }
                        }, function (err) {
                            $log.warn("'custom-template' directive was unable to download custom template. Nothing rendered!");
                            return $q.reject(err);
                        });
                }

                function connectHTML(html) {
                    element.empty();
                    element.append($compile(html)(scope)); // unsafe!
                }

            };

            attributes.$observe(
                "name",
                function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        recompile();
                    }
                }
            );
            attributes.$observe(
                "context",
                function (newVal, oldVal) {
                    if (newVal != oldVal) {
                        recompile();
                    }
                }
            );

            //Subscribe to the context changed event to recompile directive and redraw the content if any
            //in order to reflect the template change according to the new context (user or any other customisation data)
            if (context) {
                context.events.on('changed', function () {
                    recompile();
                });
            }

            recompile();
        }

        return {
            restrict: 'E',
            link: link
        };
    })
;